<template>
  <div id="user-binging">
    <div>
      <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :destroy-on-close="true"
        :visible.sync="dialogVisible"
        width="460px"
        @close="closeModal"
      >
        <div slot="title">
          <span class="b-modal-title">邀请链接生成成功</span>
        </div>
        <el-form ref="formData" :model="formData" :rules="rules">
          <div class="b-flex b-flex-space-between qrcode_input">
            <div
              v-loading="qrCodeLoading"
              customClass="loading-all"
              element-loading-background="rgba(255, 255, 255,1)"
              element-loading-custom-class="loading-all"
              element-loading-text="生成邀请二维码...请稍等"
              style="text-align: center; height: 300px"
            >
              <div
                id="poster-container"
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  flex-flow: column;
                "
              >
                <div>
                  <span style="color: #888888">{{ qrCode.UserDisplayName }}</span>
                  <span style="color: #888888; margin-left: -4px;">邀请您加入二维码平台</span>
                </div>
                <p style="margin: 0.25em 0 1em; color: rgb(34, 34, 34); font-weight: bold">
                  "{{ qrCode.ProjectName }}"项目
                </p>
                <div id="img-father" class="img-fa" style="background: transparent">
                  <vue-qrcode
                    :color="colors"
                    :margin="margin"
                    :quality="quality"
                    :type="type"
                    :value="qrcodeValue"
                    :width="width"
                  ></vue-qrcode>
                </div>
              </div>
              <span class="bottom-alert">
                <span style="display: inline-block; width: 150px">截图或右键复制图片到微信</span>
              </span>
            </div>
          </div>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import html2canvas from 'html2canvas'
import VueQrcode from 'vue-qrcode'

let _this = void 0

export default {
  name: 'InviteUser',
  components: {
    VueQrcode,
  },
  filters: {},
  directives: {},
  mixins: [],
  props: {
    inviteUserProp: {
      type: Boolean,
      default: false,
    },
    linkProp: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialogVisible: false,
      link: '',
      formData: {
        projectID: null,
        link: null,
      },
      rules: {
        projectID: [{ required: true, message: '请选择项目', trigger: 'change' }],
      },
      qrCode: {
        UserDisplayName: null,
        ProjectName: null,
      },
      wxURL: '', // 微信Url
      dataLink: '', // 邀请用户链接
      socket: null,
      showQrCode: true, // 是否显示失效信息
      qrcodeSrcWeChat: '',
      ticket: '',
      qrCodeLoading: true,
      // 二维码生成图片的格式
      type: 'image/png',
      // 二维码色块值   width: 187,
      colors: {
        dark: '#000000FF',
        light: '#FFFFFFFF',
      },
      // 二维码外边距(px)
      margin: 0,
      // 二维码质量 0~1
      quality: 1,
      // 二维码边长(px)
      width: 180,
      // 二维码值
      qrcodeValue: '自定义标题',
    }
  },
  computed: {
    // ...mapState('', {}),
  },
  watch: {
    inviteUserProp(val) {
      this.dialogVisible = val
    },
    linkProp(val) {
      this.link = val
    },
  },
  async created() {
    _this = this
    await _this.getUrl()
    await _this.getSocket()
    window.onunload = function deleteTimer() {
      _this.socket.close()
      clearInterval(timer)
    }
  },
  mounted() {
    this.qrCode.UserDisplayName = JSON.parse(localStorage.getItem('USER_INFO')).DisplayName
    this.qrCode.ProjectName = this.projectName()
  },
  destroy() {},
  methods: {
    ...mapGetters('user', {
      getUserInfo: 'USER_INFO',
    }),
		...mapGetters({
      projectName: 'getProjectName',
      getProjectId: 'getProjectId',
		}),
    /*
     * 复制二维码
     * */
    copyQR() {
      const _ = this
      const imgFather = document.getElementById('poster-container')
      if (imgFather.innerHTML !== '') {
        const img = document.getElementById('poster-container')
        img.focus()
        this.$nextTick(() => {
          html2canvas(imgFather, {
            imageTimeout: 2e3,
          }).then(canvas => {
            const image = new Image()
            image.className = 'image-post'
            image.src = canvas.toDataURL('image/png')
            if (document.querySelector('#poster-container')) {
              document.querySelector('#poster-container').innerHTML = ''
              document.querySelector('#poster-container').appendChild(image)
            }
            _.qrCodeLoading = false
          })
        })
      }
    },

    closeModal() {
      _this.$emit('close-invite-user-modal')
    },
    // 点击邀请用户按钮,获取邀请链接数据
    async openInviteUser() {
      this.qrCodeLoading = true
      this.qrcodeSrcWeChat = ''
      const { success, data } = await this.$http({
        url: this.$api.makeInvitationToke,
        method: 'post',
        data: {
          projectID: this.getProjectId(),
        },
      })
      if (success) {
        _this.link = data
        _this.qrcodeValue = data
        const [, dataLink] = data.split('=')
        _this.dataLink = dataLink
        const timer = setTimeout(() => {
          _this.copyQR()
          clearTimeout(timer)
        }, 1e3)
      }
      this.$message({
        type: success ? 'success' : 'error',
        message: success ? '获取邀请链接成功！' : '获取邀请连接失败！',
      })
    },
    /*
     * 获取二维码链接
     * */
    async getUrl() {
      const _ = this
      const { success, data } = await this.$http({
        url: '/api/UserActivation/GetUserActivationUrl',
        method: 'Get',
      })
      if (success) {
        _.wxURL = data.WSURL
      } else {
        this.$message({
          type: 'error',
          message: '微信登录失败！',
        })
      }
    },
    /**
     * 通知server返回信息
     * @param ticket {string} 凭证
     */
    sendSocketTicket(ticket) {
      this.socket.send(
        JSON.stringify({
          Module: 'Common',
          Action: 'SetCurrentUserByUniqueIdentification',
          Param: {
            UniqueIdentification: ticket,
            Channel: 'Web',
          },
        }),
      )
    },
    /**
     * 获取serve返回的信息
     */
    getSocket() {
      this.socket = new WebSocket(this.wxURL)
      this.socket.addEventListener('message', () => {
        // const data = JSON.parse(event.data)
      })
    },
    /*
     * 复制链接
     * */
    copyInvitationToke() {
      const { DisplayName } = this.getUserInfo()
      const projectName = this.projectName()
      const element = document.createElement('textarea')
      element.value = `${this.link} ${DisplayName}邀请您加入二维码管理系统-"${projectName}"`
      document.body.appendChild(element)
      element.select()
      document.execCommand('copy')
      document.body.removeChild(element)
      this.$message({
        type: 'success',
        message: '复制链接成功！',
      })
    },
    /**
     * 把图片转成base64
     */
    getBase64Image(img) {
      const canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      const ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0, img.width, img.height)
      // 图片的格式
      const ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase()
      return canvas.toDataURL(`image/${ext}`)
    },
  },
}
</script>
<style lang="scss" scoped>
.invite-user-modal-box {
  display: flex;
  align-items: baseline;
  justify-content: center;
  padding-bottom: 10px;
}

.link-input {
  flex: 3;
  padding: 0 10px;
}

.altTipQrCode {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  height: 250px;
  width: 250px;
  margin-bottom: 2px;
}

#poster-container {
  position: relative;
  width: 432px;
  height: 271px;
}

.bottom-alert {
  display: block;
  font-size: 12px;
  color: #bababa;
  margin-top: 0.5em;
  padding-bottom: 0.5em;
}

.loading-all .circular {
  width: 48px !important;
  height: 48px !important;
}

.loading-all {
  margin-bottom: -1.5em;
}

#img-father {
  width: 250px;
  height: 187px;
  text-align: center;
  line-height: 200px;
}

.copy-btn-box {
  flex: 1;
  padding-left: 10px;
}

.el-dialog__title {
  font-size: 16px !important;
}
</style>
<style></style>
